module.exports = __webpack_public_path__ + "static/media/demand.b81f4a38.png";